'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
require('../../../utils/getThemeProp.js');
require('../../../utils/colors.js');
require('../../../utils/dates.js');
require('../../../utils/numbers.js');
require('../../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
var strings = require('../../../utils/strings.js');
require('../../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
var styles = require('@material-ui/core/styles');
require('../../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../../utils/safeFetch.js');
require('../../../utils/dom.js');
var CardRow = require('../../../CardRow/CardRow.js');
var Tooltip = _interopDefault(require('@material-ui/core/Tooltip'));
var utils = require('./utils.js');
var styledComponents = require('./styled-components.js');

var fmPrefix = 'componentLib.appWide';
var AppointmentCalendarAppointmentCard = function (props) {
    var fm = reactIntl.useIntl().formatMessage;
    var column = props.column, _a = props.darkness, darkness = _a === void 0 ? 1 : _a, data = props.data, icon = props.icon, onClick = props.onClick, showTooltip = props.showTooltip, _b = props.status, status = _b === void 0 ? 'booked' : _b, timeEnd = props.timeEnd, timeStart = props.timeStart;
    var timeEndForDuration = timeEnd;
    if (timeEnd.format('D') !== timeStart.format('D')) {
        timeEndForDuration = timeStart.clone().endOf('day');
    }
    var diff = timeEndForDuration.diff(timeStart) / 60000;
    var _c = React__default.useState(false), overflowing = _c[0], setOverflowing = _c[1];
    var handleClick = function () {
        if (onClick)
            onClick(data);
    };
    var styles$1 = styledComponents.getTooltipStyles(status, darkness);
    var ref = React__default.createRef();
    var useStyles = styles.makeStyles(function () { return styles.createStyles(styles$1); });
    var createdClasses = useStyles();
    var onMouseEnter = function (event) {
        var allowedDifference = 16; // In px. Depends on the font you are using
        setOverflowing(event.currentTarget.offsetHeight + allowedDifference < event.currentTarget.scrollHeight);
    };
    var appointmentCard = (React__default.createElement(styledComponents.AppointmentCard, { onClick: handleClick, onMouseEnter: onMouseEnter, ref: ref },
        React__default.createElement(CardRow, { left: React__default.createElement(styledComponents.TitleP, { variant: 'body1' },
                React__default.createElement("span", null, timeStart.format('h:mm A')),
                React__default.createElement("span", null, " : "),
                React__default.createElement("span", null, strings.capitalize(status))), right: icon, noMargin: true, style: { alignItems: 'center' } }),
        React__default.createElement(styledComponents.NameP, { variant: 'body1' },
            " ",
            data.name),
        data.location && (React__default.createElement(styledComponents.NameP, null,
            " ", fm({ id: fmPrefix + ".location" }) + ": " + data.location + " ")),
        data.provider && (React__default.createElement(styledComponents.NameP, { variant: 'body1' }, fm({ id: fmPrefix + ".provider" }) + ": " + utils.addSpaceToDelimiter(data.provider, ';'))),
        React__default.createElement(styledComponents.NameP, { variant: 'body1' }, strings.joinStringArray(data.notes))));
    var disableTooltip = !showTooltip && !overflowing;
    return (React__default.createElement(styledComponents.Container, { status: status, darkness: darkness, style: { minHeight: diff + "px" } },
        React__default.createElement(Tooltip, { title: appointmentCard, arrow: true, classes: {
                tooltip: createdClasses.tooltip,
                arrow: createdClasses.arrow,
            }, placement: column === 0 ? 'right' : 'left', disableHoverListener: disableTooltip, interactive: true, enterNextDelay: 200, PopperProps: {
                popperOptions: {
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: '0,0',
                        },
                    },
                },
            } }, appointmentCard)));
};

module.exports = AppointmentCalendarAppointmentCard;
